import { useNavigate } from "react-router-dom";

const RelatedService = ({ service }) => {
    const navigate = useNavigate(); 
    
    // Calculate discount percentage
    const calculateDiscountPercentage = () => {
        if (service.discountedbool && service.discountedprice && service.price) {
            const discount = ((service.price - service.discountedprice) / service.price) * 100;
            return Math.round(discount);
        }
        return 0;
    };
    
    return (
        <div
            key={service.productuid}
            onClick={() => navigate(`/services/${service.productuid}`)}
            style={{
                flex: '0 0 auto',
                width: '300px',
                borderRadius: '16px',
                height: '425px', 
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
                border: '1px solid #E6E6E6',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.10)';
                e.currentTarget.style.borderColor = '#D6D6D6';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = '#E6E6E6';
            }}
        >
            {/* Image Section */}
            <div
                style={{
                    width: '100%',
                    height: '200px',
                    position: 'relative',
                    backgroundColor: '#F6F6F6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {service.media && service.media.length > 0 ? (
                    <img
                        src={service.media[0]}
                        alt={service.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                ) : (
                    // Placeholder image
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#F0F0F0',
                        }}
                    >
                        <i 
                            className="fas fa-image" 
                            style={{
                                fontSize: '3rem',
                                color: '#C4C4C4',
                            }}
                        />
                    </div>
                )}
            </div>

            {/* Content Section */}
            <div
                style={{
                    padding: '1.25rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem',
                }}
            >
                {/* Product Name */}
                <h3
                    style={{
                        fontSize: '23px',
                        fontWeight: '600',
                        color: '#000000',
                        lineHeight: '1.4',
                        margin: '0',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        minHeight: '2.8rem', // Ensures consistent height even with 1 line
                    }}
                >
                    {service.name}
                </h3>

                {/* Category and Bundle Info */}
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    {service.bundleqty && (
                        <span
                            style={{
                                color: '#000000',
                                fontSize: '16px',
                                fontWeight: '600',
                                background: '#EDEDED',
                                padding: '4px 10px',
                                borderRadius: '6px',
                            }}
                        >
                            {service.bundleqty} sessions
                        </span>
                    )}
                    
                    {service.category && (
                        <>
                            {service.bundleqty && (
                                <span 
                                    style={{
                                        color: '#C4C4C4',
                                        fontSize: '13px',
                                    }}
                                >
                                    ·
                                </span>
                            )}
                            <span
                                style={{
                                    color: '#767676',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    background: '#F6F6F6',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                }}
                            >
                                {service.category}
                            </span>
                        </>
                    )}
                </div>

                {/* Price */}
                <div
                    style={{
                        marginTop: '10px',
                        paddingTop: '0.75rem',
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: '0.5rem',
                    }}
                >
                    {service.discountedbool && service.discountedprice ? (
                        <>
                            <span
                                style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#000000',
                                }}
                            >
                                ${service.discountedprice}
                            </span>
                            <span
                                style={{
                                    fontSize: '1rem',
                                    color: '#A3A3A3',
                                    textDecoration: 'line-through',
                                }}
                            >
                                ${service.price}
                            </span>
                            <span
                                style={{
                                    fontSize: '0.875rem',
                                    fontWeight: '600',
                                    color: '#FFFFFF',
                                    backgroundColor: '#000000',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    marginLeft: '4px',
                                }}
                            >
                                {calculateDiscountPercentage()}% OFF
                            </span>
                        </>
                    ) : (
                        <span
                            style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#000000',
                            }}
                        >
                            ${service.price}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RelatedService;